module.exports = __webpack_public_path__ + "static/media/tsi_help3.273f2ef4.png";